import { Injectable } from '@angular/core';

import { Observable, Observer, from as fromPromise, shareReplay, switchMap } from 'rxjs';
import * as _ from 'underscore';

import { IRemoteBetslipBet } from '../../core/services/remoteBetslip/remote-betslip.constant';
import { IQuickbetReceiptErrorModel, ISRMBetPlacementModel } from '../../quickbet/models/quickbet-receipt.model';
import { QuickbetService } from '../../quickbet/services/quickbetService/quickbet.service';

@Injectable({ providedIn: 'root' })
export class SRMQuickbetService extends QuickbetService {
    /**
     * Place bet
     * @param {Object} bet
     * @returns {Observable<ISRMBetPlacementModel>}
     */
    srmPlaceBet(bet: IRemoteBetslipBet): Observable<ISRMBetPlacementModel[] | IQuickbetReceiptErrorModel> {
        const observable = Observable.create((observer: Observer<ISRMBetPlacementModel[] | IQuickbetReceiptErrorModel>) => {
            this.awsService.addAction('srmQuickBetService=>placeBet=>Start', { date: new Date().getTime() });
            return this.srmPlaceBetRequest(bet).subscribe(
                (result) => {
                    observer.next(result);
                    observer.complete();
                },
                (error: IQuickbetReceiptErrorModel) => {
                    this.awsService.addAction('srmQuickBetService=>srmplaceBet=>error', error);
                    if (error.code === 'UNAUTHORIZED_ACCESS' || error.subErrorCode === 'EXTERNAL_FUNDS_UNAVAILABLE') {
                        this.awsService.addAction('srmQuickBetService=>srmplaceBet=>ErrorRetry', error);
                        if (!_.isEmpty(this.getStoredSelectionState())) {
                            fromPromise(this.commandService.executeAsync(this.commandService.API.BPP_AUTH_SEQUENCE))
                                .pipe(
                                    switchMap(() => {
                                        bet.token = this.userService.bppToken;
                                        this.awsService.addAction('srmQuickBetService=>placeBet=>Error=>bppTokenUpdate', { bet: error });
                                        return this.srmPlaceBetRequest(bet);
                                    }),
                                )
                                /* eslint-disable */
                                .subscribe(
                                    (result) => {
                                        observer.next(result);
                                        observer.complete();
                                    },
                                    (err) => {
                                        observer.error(err);
                                        observer.complete();
                                    },
                                );
                            /* eslint-enable */
                        }
                    } else {
                        observer.error(error);
                        observer.complete();
                    }
                },
            );
        });

        return observable.pipe(shareReplay(1));
    }

    /**
     * Perform request
     * @param {Object} bet
     * @returns {Observable<IQuickbetReceiptModel>}
     */
    protected srmPlaceBetRequest(bet: IRemoteBetslipBet): Observable<ISRMBetPlacementModel[]> {
        return Observable.create((observer: Observer<ISRMBetPlacementModel[]>) => {
            this.remoteBetslipService.placeBet(bet).subscribe(
                (response) => {
                    let srmReceipt = response.betPlacement,
                        srmError = response?.betFailure?.[0];

                    if (srmReceipt && srmReceipt.length > 0) {
                        observer.next(srmReceipt);
                        observer.complete();
                        return;
                    }

                    if (response.data && response.data.error) {
                        observer.error(response.data.error);
                        observer.complete();
                        return;
                    }

                    observer.error(srmError);
                    observer.complete();
                },
                (error) => {
                    observer.error(error.data.error);
                    observer.complete();
                },
            );
        }).pipe(shareReplay(1));
    }
}
